module.exports = __webpack_public_path__ + "static/projekt_indywidualny_a10-07099b4a3db166f4f43a00cbe6b95ba6.jpg";